import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isEmail } from 'utils/helpers';
import i18n, { SettingsType } from 'utils/i18n';
// import i18n from 'utils/i18n';
import Button from './button';

type ClaimBadgeFormProps = {
  assessmentId: string;
  onComplete: () => void;
};

export const ClaimBadgeForm: React.FC<ClaimBadgeFormProps> = ({ assessmentId, onComplete }) => {
  const { locale } = useRouter();
  // const { dictionary } = i18n[(locale as AcceptedLocales) || 'en-US'];
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { dictionary } = i18n[(locale as AcceptedLocales) || 'en-US'] as SettingsType; // eslint-disable-line

  useEffect(() => {
    const cachedEmail = localStorage.getItem('continia.badge.email');
    if (cachedEmail) {
      setEmail(cachedEmail);
    }
  }, []);

  const handleOnSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!isEmail(email)) {
      setError(dictionary.assessmentClaimFormValidationError);
      setLoading(false);
      return;
    }

    // Save to storage
    localStorage.setItem('continia.badge.email', email);

    const res = await fetch('/api/claim-assessment-badge', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        assessmentId,
        locale,
      }),
    });
    if (res.status === 200) {
      setEmail('');
      onComplete();
    } else {
      const json = await res.json();
      setError(json.error || '');
    }
    setLoading(false);
  };

  return (
    <StyledClaimBadgeForm>
      <div className="claim-text">
        <p>{dictionary.assessmentClaimModalBody}</p>
        <p>{dictionary.assessmentClaimModalBody2}</p>
      </div>

      <form onSubmit={handleOnSubmit}>
        <label htmlFor="email">{dictionary.assessmentClaimFormEmailLabel}</label>
        <input
          type="email"
          name="email"
          className="input"
          onChange={(e) => setEmail(e.target.value)}
          placeholder={dictionary.assessmentClaimFormEmailPlaceholder}
          value={email}
          required
        />
        {error && <div className="error">{error}</div>}
        <Button disabled={!isEmail(email)} htmlType="submit" mode="primary" loading={loading}>
          {dictionary.assessmentClaimFormSubmitBtn}
        </Button>
      </form>
    </StyledClaimBadgeForm>
  );
};

export const StyledClaimBadgeForm = styled.div`
  .claim-text {
    margin: 1rem 0;

    p {
      margin: 0;
    }
  }

  label {
    margin: 1rem 0 0 0;
    font-weight: 600;
  }

  .error {
    color: var(--danger-base);
    font-weight: 600;
    margin: 0.4rem 0;
  }

  input {
    margin: 0.3rem 0 1rem 0;
  }
`;

export default ClaimBadgeForm;
